import React, { useState } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { Layout, Row, Col } from "antd"
import Header from "../components/PageLayout/Header"

import SidebarWrapper from "../components/PageLayout/Sidebar"
import PostCard from "../components/PostCard"
import SEO from "../components/Seo"
import MiniTag from "../components/MiniTag"
import Config from "../../config"
import { Link } from "gatsby"
import notfound from '../images/notfound2.jpg'

const Blog = props => {
  const { data } = props
  const allPosts = data.allMarkdownRemark.edges
  const emptyQuery = ""
  const [state, setState] = useState({
    filteredData: [],
    query: emptyQuery,
  })

  const handleInputChange = event => {
    const query = event.target.value
    const { data } = props

    const posts = data.allMarkdownRemark.edges || []

    const filteredData = posts.filter(post => {
      const { excerpt, title, tags } = post.node.frontmatter
      return (
        excerpt.toLowerCase().includes(query.toLowerCase()) ||
        title.toLowerCase().includes(query.toLowerCase()) ||
        (tags &&
          tags
            .join("")
            .toLowerCase()
            .includes(query.toLowerCase()))
      )
    })

    setState({
      query,
      filteredData,
    })
  }

  const { filteredData, query } = state
  const hasSearchResults = filteredData && query !== emptyQuery
  const posts = hasSearchResults ? filteredData : allPosts

  const {
    allFile: { edges },
  } = data
  const rawTags = data.allMarkdownRemark.edges
    .map(edge => edge.node.frontmatter.tags)
    .reduce((prev, curr) => prev.concat(curr))
  rawTags.filter((tag, index) => index === rawTags.indexOf(tag)).sort() // Remove duplicates and sort values
  // const tagPage = Config.pages.tag;
  const tagData = Config.tags
  const tags = edges.sort().slice(0, 10)
  return (
    <Layout className="outerPadding bgWhite">
      <Header />
      <div className="topTitle">
        <div className="container wallpaper">
          <h1 className="titleSeparate">
            Learning <br /> experimenting,
            <br /> and liberating our ability.
          </h1>
        </div>
      </div>
      <Layout className="container">
        <SEO
          title="Blog"
          description="I like blogging about various web technologies and other stuff related to
            javascript and other trends like graphql, prisma etc. This blog expresses my views of various technologies
            and scenarios I have come across in realtime."
          path="blog"
        />

        <SidebarWrapper className="sidebar">
          <div className="topicBox">
            <div className="contentBox">
              <div className="lates-title">
                <h2>Latest</h2>
              </div>
              <div>
                { !posts.length &&
                  <div className="notFound">
                    <h4>Hmm!...There is no article that matches</h4>
                    <img src={notfound} alt=""/>
                  </div>
                }
              </div>
              <Row gutter={[25, 25]}>
                {posts.map((val, key) => (
                  <Col key={key} xs={24} sm={24} md={12} lg={12}>
                    <PostCard data={val} />
                  </Col>
                  ))}
              </Row>
            </div>
            <div className="tagBox">
              <div className="Card InputContainer">
                <input placeholder="Let's search..." onChange={handleInputChange}/>
              </div>
              <h3 className="tag-title">Discover what matters to you</h3>
              <Row>
                {tags.map((val, i) => (
                  <MiniTag
                    key={i}
                    name={val.node.name}
                    color={tagData[val.node.name].color}
                  />
                ))}
              </Row>
              <div className="loadMore">
                <Link to="/tags">See all topics {">"}</Link>
              </div>
            </div>
          </div>
        </SidebarWrapper>
      </Layout>
    </Layout>
  )
}

Blog.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    }).isRequired,
    allFile: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            name: PropTypes.string.isRequired,
            childImageSharp: PropTypes.shape({
              fluid: PropTypes.object.isRequired,
            }).isRequired,
          }).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
}

export const query = graphql`
  {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fileAbsolutePath: { regex: "/index.md$/" } }
    ) {
      edges {
        node {
          frontmatter {
            date
            path
            title
            tags
            excerpt
            cover {
              childImageSharp {
                fluid(maxWidth: 288) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
      }
    }
    allFile(filter: { relativeDirectory: { eq: "tags" } }) {
      edges {
        node {
          name
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`

export default Blog
